export default __webpack_public_path__ + "media/images/avatars/avatar5-d1f7d5e395bf47b0daf97ca1eaa034f1.png";